var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluePlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 26.7671C29 23.9043 32.0999 22.0927 34.6342 23.4709L58.0309 36.204C60.6564 37.6324 60.6564 41.3659 58.0309 42.7962L34.6363 55.5293C32.102 56.9075 29.002 55.094 29.002 52.2332L29 26.7671Z",
    fill: "#1197FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePlayButton);
export default __webpack_public_path__ + "static/media/bluePlayButton.c0b8ad4a0846938957aac0bb7b2eae9c.svg";
export { ForwardRef as ReactComponent };